'use client';

import { c as _c } from "react/compiler-runtime";
import { Alert, IconButton, Stack, Typography } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { Icon } from '@/components/shared/icon';
export const OfflineBanner = () => {
  const $ = _c(11);
  const [state, setState] = useState("online");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setState("online");
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const handleOnline = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setState(_temp);
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleOffline = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setState("dismissed");
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleDismiss = t2;
  let t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      window.addEventListener("online", handleOnline);
      window.addEventListener("offline", handleOffline);
      return () => {
        window.removeEventListener("online", handleOnline);
        window.removeEventListener("offline", handleOffline);
      };
    };
    t4 = [handleOnline, handleOffline];
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  useEffect(t3, t4);
  const isVisible = state === "offline";
  if (!isVisible) {
    return null;
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <i className="material-symbols-error-outline-rounded" style={{
      fontSize: "24px",
      color: "inherit"
    }} />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      position: "fixed",
      top: "100px",
      left: 0,
      right: 0,
      marginInline: "auto",
      width: "fit-content",
      zIndex: 9999,
      minWidth: "320px",
      maxWidth: "500px",
      boxShadow: "var(--mui-customShadows-lg)",
      borderRadius: "12px",
      padding: "12px 16px",
      animation: "slideDown 0.3s ease-out",
      "@keyframes slideDown": {
        from: {
          transform: "translateY(-100%)",
          opacity: 0
        },
        to: {
          transform: "translateY(0)",
          opacity: 1
        }
      },
      "& .MuiAlert-icon": {
        alignItems: "center"
      },
      "& .MuiAlert-action": {
        alignItems: "center"
      }
    };
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <IconButton aria-label="dismiss" onClick={handleDismiss} sx={{
      color: "inherit",
      borderRadius: "4px",
      padding: "0px",
      "&.MuiIconButton-root:hover": {
        backgroundColor: "var(--mui-palette-action-focus)"
      }
    }}><Icon iconClass="material-symbols-close-rounded" color="inherit" /></IconButton>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      gap: "2px"
    };
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Typography variant="subtitle2Strong" sx={{
      color: "inherit"
    }}>No Internet Connection</Typography>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Alert severity="error" variant="filled" icon={t5} sx={t6} action={t7}><Stack sx={t8}>{t9}<Typography variant="subtitle2" sx={{
          color: "inherit",
          opacity: 0.9
        }}>Please check your network connection</Typography></Stack></Alert>;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  return t10;
};
function _temp(prev) {
  if (prev === "online") {
    return "offline";
  }
  return prev;
}